import {
  Q0_FIELD,
  stepsForProfile,
  type ProfileCode,
  type SurveyFieldDef,
} from "../survey/config";

function profileToCode(profile: string | null | undefined): ProfileCode {
  if (profile === "p1") return "p1";
  if (profile === "p3") return "p3";
  return "p2";
}

export function buildFieldMap(): Map<string, SurveyFieldDef> {
  const m = new Map<string, SurveyFieldDef>();
  m.set(Q0_FIELD.id, Q0_FIELD);
  for (const pr of ["p1", "p2", "p3"] as ProfileCode[]) {
    for (const st of stepsForProfile(pr)) {
      for (const f of st.fields) m.set(f.id, f);
    }
  }
  return m;
}

function optLabel(
  f: SurveyFieldDef | undefined,
  value: string,
): string {
  return f?.options?.find((o) => o.value === value)?.label ?? value;
}

export function formatFieldValue(
  f: SurveyFieldDef | undefined,
  v: unknown,
): string {
  if (v === undefined || v === null || v === "") return "—";
  if (f?.type === "multi" && Array.isArray(v)) {
    return (v as string[])
      .map((x) => optLabel(f, x))
      .join(", ");
  }
  if (typeof v === "string") return optLabel(f, v);
  if (typeof v === "boolean") return v ? "Sí" : "No";
  return String(v);
}

export function orderedAnswerEntries(
  profile: string | null | undefined,
  answers: Record<string, unknown>,
): { id: string; label: string; text: string }[] {
  const pr = profileToCode(profile);
  const map = buildFieldMap();
  const seen = new Set<string>();
  const out: { id: string; label: string; text: string }[] = [];

  const push = (id: string) => {
    if (seen.has(id) || !(id in answers) || id === "website") return;
    seen.add(id);
    const f = map.get(id);
    const label = f?.label ?? id;
    out.push({ id, label, text: formatFieldValue(f, answers[id]) });
  };

  push("q0_profile");
  push("profile");
  for (const st of stepsForProfile(pr)) {
    for (const field of st.fields) push(field.id);
  }
  if (typeof answers.consent === "boolean") {
    out.push({
      id: "consent",
      label: "Consentimiento",
      text: answers.consent ? "Sí" : "No",
    });
  }
  return out;
}
